export var ParentType;
(function (ParentType) {
    /** Acceptance */
    ParentType["Acceptance"] = "acceptance";
    /** Action */
    ParentType["Action"] = "action";
    /** Action Update */
    ParentType["ActionUpdate"] = "action_update";
    /** Appetite */
    ParentType["Appetite"] = "appetite";
    /** Approval result */
    ParentType["ApprovalResult"] = "approval_result";
    /** Assessment */
    ParentType["Assessment"] = "assessment";
    /** Assessment Activity */
    ParentType["AssessmentActivity"] = "assessment_activity";
    /** Attestation Record */
    ParentType["AttestationRecord"] = "attestation_record";
    /** Audit entities */
    ParentType["Audit"] = "audit";
    /** Business Area */
    ParentType["BusinessArea"] = "business_area";
    /** Cause */
    ParentType["Cause"] = "cause";
    /** Change Request */
    ParentType["ChangeRequest"] = "change_request";
    /** Compliance Monitoring Assessment */
    ParentType["ComplianceMonitoringAssessment"] = "compliance_monitoring_assessment";
    /** Consequence */
    ParentType["Consequence"] = "consequence";
    /** Control */
    ParentType["Control"] = "control";
    /** Control Group */
    ParentType["ControlGroup"] = "control_group";
    /** Controlled Risk Assessment Result */
    ParentType["ControlledRiskAssessmentResult"] = "controlled_risk_assessment_result";
    /** Control test internal audit result */
    ParentType["ControlTestInternalAuditResult"] = "control_test_internal_audit_result";
    /** Control test second line result */
    ParentType["ControlTestSecondLineResult"] = "control_test_second_line_result";
    /** Conversation */
    ParentType["Conversation"] = "conversation";
    /** Custom attribute schema */
    ParentType["CustomAttributeSchema"] = "custom_attribute_schema";
    /** CustomDatasource */
    ParentType["CustomDatasource"] = "custom_datasource";
    /** Custom Ribbon Item */
    ParentType["CustomRibbon"] = "custom_ribbon";
    /** Dashboard */
    ParentType["Dashboard"] = "dashboard";
    /** Data Export */
    ParentType["DataExport"] = "data_export";
    /** Data Import */
    ParentType["DataImport"] = "data_import";
    /** Department Type */
    ParentType["DepartmentType"] = "department_type";
    /** Document */
    ParentType["Document"] = "document";
    /** Document Assessment */
    ParentType["DocumentAssessment"] = "document_assessment";
    /** Document Assessment Result */
    ParentType["DocumentAssessmentResult"] = "document_assessment_result";
    /** Document version */
    ParentType["DocumentFile"] = "document_file";
    /** Document internal audit result */
    ParentType["DocumentInternalAuditResult"] = "document_internal_audit_result";
    /** Document second line result */
    ParentType["DocumentSecondLineResult"] = "document_second_line_result";
    /** Enterprise Risk */
    ParentType["EnterpriseRisk"] = "enterprise_risk";
    /** Entity */
    ParentType["Entity"] = "entity";
    /** Impact */
    ParentType["Impact"] = "impact";
    /** Impact internal audit rating */
    ParentType["ImpactInternalAuditRating"] = "impact_internal_audit_rating";
    /** Impact Parent */
    ParentType["ImpactParent"] = "impact_parent";
    /** Impact rating */
    ParentType["ImpactRating"] = "impact_rating";
    /** Impact second line rating */
    ParentType["ImpactSecondLineRating"] = "impact_second_line_rating";
    /** Indicator */
    ParentType["Indicator"] = "indicator";
    /** Indicator Result */
    ParentType["IndicatorResult"] = "indicator_result";
    /** Internal Audit */
    ParentType["InternalAuditEntity"] = "internal_audit_entity";
    /** Internal Audit Report */
    ParentType["InternalAuditReport"] = "internal_audit_report";
    /** Issue */
    ParentType["Issue"] = "issue";
    /** Issue Assessment */
    ParentType["IssueAssessment"] = "issue_assessment";
    /** Issue assessment audit */
    ParentType["IssueAssessmentAudit"] = "issue_assessment_audit";
    /** issue assessment breach log */
    ParentType["IssueAssessmentBreachLog"] = "issue_assessment_breach_log";
    /** issue assessment consumer duty */
    ParentType["IssueAssessmentConsumerDuty"] = "issue_assessment_consumer_duty";
    /** issue assessment customer trust */
    ParentType["IssueAssessmentCustomerTrust"] = "issue_assessment_customer_trust";
    /** issue assessment gdpr breach log */
    ParentType["IssueAssessmentGdprBreachLog"] = "issue_assessment_gdpr_breach_log";
    /** issue assessment pci breach log */
    ParentType["IssueAssessmentPciBreachLog"] = "issue_assessment_pci_breach_log";
    /** issue assessment risk event */
    ParentType["IssueAssessmentRiskEvent"] = "issue_assessment_risk_event";
    /** issue assessment sar log */
    ParentType["IssueAssessmentSarLog"] = "issue_assessment_sar_log";
    /** issue breach log */
    ParentType["IssueBreachLog"] = "issue_breach_log";
    /** issue consumer duty */
    ParentType["IssueConsumerDuty"] = "issue_consumer_duty";
    /** issue customer trust */
    ParentType["IssueCustomerTrust"] = "issue_customer_trust";
    /** issue gdpr breach log */
    ParentType["IssueGdprBreachLog"] = "issue_gdpr_breach_log";
    /** issue pci breach log */
    ParentType["IssuePciBreachLog"] = "issue_pci_breach_log";
    /** issue risk event */
    ParentType["IssueRiskEvent"] = "issue_risk_event";
    /** issue sar log */
    ParentType["IssueSarLog"] = "issue_sar_log";
    /** Issue Update */
    ParentType["IssueUpdate"] = "issue_update";
    /** Linked item */
    ParentType["LinkedItem"] = "linked_item";
    /** Multiple datasource reporting */
    ParentType["MultiReporting"] = "multi_reporting";
    /** My items */
    ParentType["MyItems"] = "my_items";
    /** Notification */
    ParentType["Notification"] = "notification";
    /** Obligation */
    ParentType["Obligation"] = "obligation";
    /** Obligation Assessment */
    ParentType["ObligationAssessment"] = "obligation_assessment";
    /** Obligation Assessment Result */
    ParentType["ObligationAssessmentResult"] = "obligation_assessment_result";
    /** Obligation Impact */
    ParentType["ObligationImpact"] = "obligation_impact";
    /** Obligation internal audit result */
    ParentType["ObligationInternalAuditResult"] = "obligation_internal_audit_result";
    /** Obligation second line result */
    ParentType["ObligationSecondLineResult"] = "obligation_second_line_result";
    /** Organisation shared dashboards */
    ParentType["OrganisationDashboard"] = "organisation_dashboard";
    /** Organisation Tab Preference */
    ParentType["OrganisationTabPreference"] = "organisation_tab_preference";
    /** Public issue form */
    ParentType["PublicIssueForm"] = "public_issue_form";
    /** Public policies */
    ParentType["PublicPolicies"] = "public_policies";
    /** Questionnaire Template */
    ParentType["QuestionnaireTemplate"] = "questionnaire_template";
    /** Questionnaire Template Version */
    ParentType["QuestionnaireTemplateVersion"] = "questionnaire_template_version";
    /** Reports */
    ParentType["Report"] = "report";
    /** Risk */
    ParentType["Risk"] = "risk";
    /** Risk assessment */
    ParentType["RiskAssessment"] = "risk_assessment";
    /** Risk Assessment Result */
    ParentType["RiskAssessmentResult"] = "risk_assessment_result";
    /** Risk Assessment Result Config **/
    ParentType["RiskAssessmentResultConfig"] = "risk_assessment_result_config";
    /** Risk Controlled Assessment */
    ParentType["RiskControlledAssessment"] = "risk_controlled_assessment";
    /** Risk controlled internal audit result */
    ParentType["RiskControlledInternalAuditResult"] = "risk_controlled_internal_audit_result";
    /** Risk controlled second line result */
    ParentType["RiskControlledSecondLineResult"] = "risk_controlled_second_line_result";
    /** Tier 1 risk */
    ParentType["RiskTier1"] = "risk_tier_1";
    /** Risk Uncontrolled Assessment */
    ParentType["RiskUncontrolledAssessment"] = "risk_uncontrolled_assessment";
    /** Risk uncontrolled internal audit result */
    ParentType["RiskUncontrolledInternalAuditResult"] = "risk_uncontrolled_internal_audit_result";
    /** Risk uncontrolled second line result */
    ParentType["RiskUncontrolledSecondLineResult"] = "risk_uncontrolled_second_line_result";
    /** Scim Configuration */
    ParentType["ScimConfiguration"] = "scim_configuration";
    /** Settings */
    ParentType["Settings"] = "settings";
    /** Approvals Settings */
    ParentType["SettingsApprovals"] = "settings_approvals";
    /** Audit Settings */
    ParentType["SettingsAudit"] = "settings_audit";
    /** Department Settings */
    ParentType["SettingsDepartments"] = "settings_departments";
    /** Tag Settings */
    ParentType["SettingsTags"] = "settings_tags";
    /** User Group Settings */
    ParentType["SettingsUserGroups"] = "settings_user_groups";
    /** User Settings */
    ParentType["SettingsUsers"] = "settings_users";
    /** Tag type */
    ParentType["TagType"] = "tag_type";
    /** Taxonomy */
    ParentType["Taxonomy"] = "taxonomy";
    /** Test Result */
    ParentType["TestResult"] = "test_result";
    /** Third Party */
    ParentType["ThirdParty"] = "third_party";
    /** Third Party Response */
    ParentType["ThirdPartyResponse"] = "third_party_response";
    /** Uncontrolled Risk Assessment Result */
    ParentType["UncontrolledRiskAssessmentResult"] = "uncontrolled_risk_assessment_result";
})(ParentType || (ParentType = {}));
//# sourceMappingURL=parent-types.js.map